var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgYoutubeBg = function SvgYoutubeBg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#191A1B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2192 13.1249C29.5497 13.4656 29.7844 13.8875 29.8997 14.348C30.2074 16.0544 30.3569 17.7855 30.346 19.5194C30.3521 21.2274 30.2027 22.9323 29.8997 24.6132C29.7844 25.0737 29.5497 25.4956 29.2192 25.8363C28.8887 26.177 28.4741 26.4245 28.0174 26.5537C26.3486 27 19.6733 27 19.6733 27C19.6733 27 12.998 27 11.3291 26.5537C10.8817 26.4313 10.4734 26.1955 10.1436 25.8692C9.81392 25.5428 9.57393 25.137 9.44687 24.6908C9.13907 22.9844 8.98967 21.2533 9.00055 19.5194C8.99205 17.7985 9.14145 16.0804 9.44687 14.3868C9.56212 13.9263 9.79685 13.5044 10.1273 13.1637C10.4578 12.823 10.8724 12.5755 11.3291 12.4463C12.998 12 19.6733 12 19.6733 12C19.6733 12 26.3486 12 28.0174 12.4075C28.4741 12.5367 28.8887 12.7842 29.2192 13.1249ZM23.0699 19.5186L17.491 22.6913V16.3459L23.0699 19.5186Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYoutubeBg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/youtube-bg.cab792b8.svg";
export { ForwardRef as ReactComponent };